var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--rotate-square-2",style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }